import { Typography } from "@mui/material";
import GetInTouchCard from "./GetInTouchCard";
import LocationBanner from "./Location";
import Faq from "./Faq";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const ContactUs = () => {
  const [ref1, inView1] = useInView();
  return (
    <motion.div
      className=" bg-[#E7F0FF] w-full font-HNmed mt-24"
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ type: "tween" }}
      exit={{ x: "100vw" }}
    >
      <div className="flex flex-col md:flex-row w-full bg-cover bg-[url('assets/images/contactuseffect.png')]">
        <motion.div
          ref={ref1}
          initial={{ opacity: 0.1, y: 100 }}
          animate={{ opacity: inView1 ? 1 : 0.1, y: 0 }}
          transition={{
            duration: 2,
          }}
          className="flex flex-col w-full md:w-[60%] m-3 text-center md:text-left p-20 "
        >
          <h1 className="font-HNmed text-3xl md:text-7xl">Contact Us</h1>
          <Typography
            variant="body"
            sx={{
              color: "#75777C",
              paddingTop: "20px",
              paddingBottom: "50px",
              fontSize: { xs: "14px", md: "18px" },
              fontFamily: "HelNeu-Light",
              letterSpacing: 0.3,
            }}
          >
            Email, call or complete the form
            <br /> to reach out to us! <br />
            <br />
            vpack7771@gmail.com
            <br /> +91 9745507771
            <br /> +91 9446468771 <br />
            <span className="text-black">
              Customer Support
              <br />
            </span>
          </Typography>
          <div className="flex flex-col md:flex-row justify-evenly">
            <div className="flex flex-col ">
              <div className="py-5 text-xl font-HNmed">
                Feedback and Suggestions
              </div>
              <div className="text-sm text-[#9F9F9F]">
                We value your feedback and are continuously working to improve
                production and efficiency. Your input is crucial in shaping the
                future of Vpack.
              </div>
            </div>
            <div className="flex flex-col pr-8">
              <div className="py-5 text-xl font-HNmed">Customization</div>
              <div className="text-sm text-[#9F9F9F]">
                Place an enquiry to get in touch with our team to customise the
                product to suit your needs
              </div>
            </div>
            <div className="flex flex-col pr-8">
              <div className="py-5 text-xl font-HNmed">Customer Support</div>
              <div className="text-sm text-[#9F9F9F]">
                We ensure high quality products are open on business hours for
                any queries related to our products and services.
              </div>
            </div>
          </div>
        </motion.div>
        <div className="my-16 mx-atuo">
          <GetInTouchCard />
        </div>
      </div>
      <div>
        <LocationBanner />
      </div>
      <div>
        <Faq />
      </div>
    </motion.div>
  );
};
export default ContactUs;
